export default "__VITE_PUBLIC_ASSET__6561c191__"